import { render, staticRenderFns } from "./FactAdd.vue?vue&type=template&id=0d38d323&scoped=true&"
import script from "./FactAdd.vue?vue&type=script&lang=js&"
export * from "./FactAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d38d323",
  null
  
)

export default component.exports